import gql from 'graphql-tag';

export default gql`
  query($categoryId: Int) {
    getShopsByCategory(categoryId: $categoryId) {
      id
      name
      type
      slug
      imgDesk
      is_new
      is_heart
      logo1Desk
      logo2Desk
      category {
        id
        detail {
          slug
          label
        }
        parent {
          id
          detail {
            slug
            label
          }
        }
      }
    }
  }
`;
